import { render, staticRenderFns } from "./fornecedor-form.vue?vue&type=template&id=91a734ba"
import script from "./fornecedor-form.vue?vue&type=script&lang=js"
export * from "./fornecedor-form.vue?vue&type=script&lang=js"
import style0 from "./fornecedor-form.vue?vue&type=style&index=0&id=91a734ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports